// Formats a duration in milliseconds into a human-readable string,
// stepping up the unit as it grows: minutes -> hours -> days -> months.
export const formatDuration = (durationMs) => {
  if (!durationMs || durationMs < 0) return '0m';

  const minutes = Math.floor(durationMs / 60000);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days >= 30) {
    const months = Math.floor(days / 30);
    const remainingDays = days % 30;
    return `${months} month${months > 1 ? 's' : ''}${remainingDays > 0 ? ` ${remainingDays}d` : ''}`;
  }

  if (days >= 1) {
    const remainingHours = hours % 24;
    return `${days} day${days > 1 ? 's' : ''}${remainingHours > 0 ? ` ${remainingHours}h` : ''}`;
  }

  if (hours >= 1) {
    return `${hours}h ${minutes % 60}m`;
  }

  return `${minutes}m`;
};
